import { DateTimeFormatter, ZonedDateTime, ZoneId } from "@js-joda/core";
import { Locale } from "@js-joda/locale_en-us";
import dayjs, { type Dayjs } from "dayjs";
import "@js-joda/timezone/dist/js-joda-timezone-10-year-range.js";

export const localZoneId = ZoneId.of("America/Chicago");

export const dayJsToZonedDateTime = (dateTime: Dayjs): ZonedDateTime =>
    ZonedDateTime.of(
        dateTime.year(),
        dateTime.month() + 1,
        dateTime.date(),
        dateTime.hour(),
        dateTime.minute(),
        0,
        0,
        localZoneId,
    );

export const zonedDateTimeToDayJs = (dateTime: ZonedDateTime): Dayjs =>
    dayjs(dateTime.withZoneSameInstant(localZoneId).toLocalDateTime().toString());

export const dateTimeFormatter = DateTimeFormatter.ofPattern("MMMM d, yyyy, h:mm a").withLocale(
    Locale.US,
);

export const shortDateTimeFormatter = DateTimeFormatter.ofPattern("MMM d, yyyy, h:mm a").withLocale(
    Locale.US,
);

export const dateFormatter = DateTimeFormatter.ofPattern("MMMM d, yyyy").withLocale(Locale.US);
